<template lang="pug">
    game-preview-settings(v-if="parameters")
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value") {{ $i18n.t('common.common_gameName_equationOnline') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_positionOfUndefined') }}
            span(slot="value") {{ $i18n.t('common.common_gameSetting_' + parameters.position) }}
        game-preview-setting(v-if="parameters.amountOfExamples")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_examples') }}
            span(slot="value") {{ parameters.amountOfExamples }}
        game-preview-setting(v-else-if="parameters.timeLimit")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_timeLimit') }}
            span(slot="value") {{ timeLimit }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_actions') }}
            span(slot="value") {{ parameters.amountOfActions }}
        game-preview-setting(v-if="parameters.amountOfUnknowns")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_unknowns') }}
            span(slot="value") {{ parameters.amountOfUnknowns }}
        game-preview-setting(v-if="parameters.stayIn5")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_stayIn', {x: 5}) }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
        game-preview-setting(v-if="parameters.stayIn10")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_stayIn', {x: 10}) }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
        game-preview-setting(v-if="parameters.stayIn20")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_stayIn', {x: 20}) }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
        game-preview-setting(v-if="parameters.stayIn100")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_stayIn', {x: 100}) }}
            span(slot="value") {{ getStayIn100Settings }}
        game-preview-setting(v-if="parameters.doubleDigits")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_doubleDigits') }}
            span(slot="value") {{ getDoubleDigitsSetting }}
        game-preview-setting(v-if="parameters.roundDoubleDigits")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_roundDoubleDigits') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
        game-preview-setting(v-if="parameters.roundTripleDigits")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_roundTripleDigits') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
</template>

<script>
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import GamePreviewSettings from './GamePreviewSettings.vue';
    import GamePreviewSetting from './GamePreviewSetting.vue';

    export default {
        props: ['parameters', 'exerciseId', 'type'],
        mixins: [TrainerUtilities],
        components: {
            GamePreviewSettings,
            GamePreviewSetting,
        },
        computed: {
            timeLimit() {
                return (
                    this.parameters.timeLimit +
                    ' ' +
                    this.$i18n.tc('trainer.trainer_gamePreview_timeParamMinuteDeclination', this.parameters.timeLimit)
                );
            },
            getStayIn100Settings() {
                if (this.parameters.position === 'inAnswer' && this.parameters.stayIn100) {
                    let string = this.parameters.withJumpThroughTenners
                        ? this.$i18n.t('trainer.trainer_gameFormSetting_withJump').toLowerCase()
                        : this.$i18n.t('trainer.trainer_gameFormSetting_withoutJump').toLowerCase();
                    return string + ' ' + this.$i18n.t('trainer.trainer_gameFormSetting_throwTenners').toLowerCase();
                } else if (this.parameters.stayIn100) {
                    return this.$i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated');
                }
                return '';
            },
            getDoubleDigitsSetting() {
                if (this.parameters.doubleDigits) {
                    if (this.parameters.position === 'inAnswer' && this.parameters.plusSingleDigits) {
                        let string = '+ ' + this.$i18n.t('trainer.trainer_gameFormSetting_singleDigits').toLowerCase();
                        return this.parameters.withSingleDigitsJump
                            ? string + ' ' + this.$i18n.t('trainer.trainer_gameFormSetting_withJump').toLowerCase()
                            : string + ' ' + this.$i18n.t('trainer.trainer_gameFormSetting_withoutJump').toLowerCase();
                    } else if (this.parameters.plusSingleDigits) {
                        return '+ ' + this.$i18n.t('trainer.trainer_gameFormSetting_singleDigits').toLowerCase();
                    } else if (this.parameters.position === 'inAnswer' && this.parameters.plusRoundDoubleDigits) {
                        return (
                            '+ ' +
                            this.$i18n.t('trainer.trainer_gameFormSetting_roundDoubleDigits').toLowerCase() +
                            ' ' +
                            this.$i18n.t('trainer.trainer_gameFormSetting_withoutJump').toLowerCase()
                        );
                    } else if (this.parameters.plusRoundDoubleDigits) {
                        return '+ ' + this.$i18n.t('trainer.trainer_gameFormSetting_roundDoubleDigits').toLowerCase();
                    }
                }
                return '';
            },
        },
    };
</script>
